import HomeScreen from './Home/Home.screen';
import PreferencesScreen from './Preferences/Preferences.screen';
import ResetPasswordScreen from './ResetPassword/ResetPassword.screen';
import AdminPanelScreen from './AdminPanel/AdminPanel.screen';
import SingleReportScreen from './SingleReport/SingleReport.screen';
import CompanyScreen from './Company/Company.screen';
import CompareScreen from './Compare/Compare.screen';
import IndustriesScreen from './Industries/Industries.screen';
import ReportScreen from './Report/Report.screen';

export {
	HomeScreen,
	PreferencesScreen,
	ResetPasswordScreen,
	AdminPanelScreen,
	SingleReportScreen,
	CompanyScreen,
	CompareScreen,
	IndustriesScreen,
	ReportScreen,
};
